"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { createRef } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { Treebeard } from "react-treebeard";
import { action, computed, observable } from "mobx";
import {
  customDecorators,
  customTheme
} from "./TreebeardDecorators";
export let FolderTree = class extends React.Component {
  constructor() {
    super(...arguments);
    this.treeParentRef = createRef();
    this.folderBeingDragged = null;
  }
  render() {
    const { className } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: classNames("treebeard", { [`${className}`]: !!className }), ref: this.treeParentRef }, /* @__PURE__ */ React.createElement(
      Treebeard,
      {
        data: this.parsedFolderData,
        onToggle: this.onToggle,
        onSelect: this.onSelect,
        decorators: customDecorators,
        style: customTheme
      }
    ));
  }
  onToggle(node) {
    this.props.viewStore.onToggle(node.id);
  }
  onSelect(node) {
    const { onSelect, viewStore } = this.props;
    const id = node.id;
    if (!viewStore.isFolderToggledOpen(id) || viewStore.isFolderSelected(id)) {
      this.onToggle(node);
    }
    onSelect(id);
  }
  handleDragStart(event, folderId) {
    const { onDragStart } = this.props;
    if (!!onDragStart) {
      onDragStart(event, folderId);
      this.folderBeingDragged = folderId;
    }
  }
  handleDragEnd() {
    this.folderBeingDragged = null;
    if (this.props.onDragEnd) {
      this.props.onDragEnd();
    }
  }
  get parsedFolderData() {
    const {
      className,
      onDragStart,
      onDropOnFolder,
      onNameChange,
      onRenameConfirm,
      onRenameCancel,
      viewStore,
      maxNameLength,
      onDeleteFolder,
      onCreateFolder,
      disableOptions
    } = this.props;
    const folders = viewStore.folders;
    const idMap = /* @__PURE__ */ new Map();
    const allTreebeardFolders = [];
    const roots = [];
    const sharedProps = {
      className,
      onDragStart: this.handleDragStart,
      onDragEnd: this.handleDragEnd,
      onDropOnFolder,
      onNameChange,
      onRenameConfirm,
      onRenameCancel,
      maxNameLength,
      onDeleteFolder,
      onCreateFolder,
      disableOptions,
      treeParentRef: this.treeParentRef
    };
    for (let i = 0; i < folders.length; ++i) {
      const folder = folders[i];
      idMap.set(folder.id, i);
      const toggled = viewStore.isFolderToggledOpen(folder.id);
      const selected = viewStore.isFolderSelected(folder.id);
      allTreebeardFolders.push({
        id: folder.id,
        name: folder.name,
        toggled,
        selected,
        renaming: folder.renaming || false,
        children: [],
        draggable: !!onDragStart,
        animationState: folder.animationState,
        isLoading: folder.isLoading,
        disableSelect: folder.disableSelect || false,
        isBeingDragged: false,
        ...sharedProps
      });
    }
    for (let i = 0; i < folders.length; ++i) {
      const folder = folders[i];
      if (!!folder.parent && idMap.has(folder.parent)) {
        const currentTreebeardFolder = allTreebeardFolders[i];
        const parentIndex = idMap.get(folder.parent);
        const parentFolder = allTreebeardFolders[parentIndex];
        parentFolder.children.push(currentTreebeardFolder);
        currentTreebeardFolder.parentId = parentFolder.id;
        if (currentTreebeardFolder.selected) {
          toggleAncestors(allTreebeardFolders, currentTreebeardFolder, idMap);
        }
      } else {
        roots.push(allTreebeardFolders[i]);
      }
    }
    if (this.folderBeingDragged && idMap.has(this.folderBeingDragged)) {
      const treebeardFolderBeingDragged = allTreebeardFolders[idMap.get(this.folderBeingDragged)];
      addBeingDraggedFlag(treebeardFolderBeingDragged);
    }
    return roots;
  }
};
FolderTree.defaultProps = {
  // This is just a reasonable default number that is used by a lot of file systems
  maxNameLength: 256
};
__decorateClass([
  observable
], FolderTree.prototype, "folderBeingDragged", 2);
__decorateClass([
  action.bound
], FolderTree.prototype, "onToggle", 1);
__decorateClass([
  action.bound
], FolderTree.prototype, "onSelect", 1);
__decorateClass([
  action.bound
], FolderTree.prototype, "handleDragStart", 1);
__decorateClass([
  action.bound
], FolderTree.prototype, "handleDragEnd", 1);
__decorateClass([
  computed
], FolderTree.prototype, "parsedFolderData", 1);
FolderTree = __decorateClass([
  observer
], FolderTree);
function toggleAncestors(allFolders, current, map) {
  if (current.parentId) {
    const parentIndex = map.get(current.parentId);
    const parent = allFolders[parentIndex];
    parent.toggled = true;
    toggleAncestors(allFolders, parent, map);
  }
}
function addBeingDraggedFlag(treebeardFolderBeingDragged) {
  const traversalQueue = [treebeardFolderBeingDragged];
  while (traversalQueue.length > 0) {
    const nextTreebeardFolder = traversalQueue.pop();
    nextTreebeardFolder.isBeingDragged = true;
    for (const child of nextTreebeardFolder.children) {
      traversalQueue.push(child);
    }
  }
}
